
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import Icon from "@/components/Icon.vue";
import { Emoji } from "v-emoji-picker/src/models/Emoji";
import { Category } from "v-emoji-picker/src/models/Category";
import { emojisDefault } from "v-emoji-picker/src/utils/emojis";
import { categoriesDefault } from "v-emoji-picker/src/utils/categories";

@Component({ components: { Icon } })
export default class EmojiPicker extends Vue {
  @Prop({ required: true }) value!: string;

  $refs!: {
    search: HTMLInputElement;
  };

  currentCategory = "Peoples";
  searchTerm = "";
  showPicker = true;

  categories: Category[] = categoriesDefault;
  emojis: Emoji[] = emojisDefault;

  get filteredCategories() {
    return this.currentCategory === "Search"
      ? []
      : this.categories.filter((c) => c.name !== "Frequently");
  }
  get groupedEmojis(): { [k: string]: Emoji[] } {
    const groups: { [k: string]: Emoji[] } = {};
    this.emojis.forEach((e: Emoji) => {
      groups[e.category] = groups[e.category] || [];
      groups[e.category].push(e);
    });
    return groups;
  }
  get emojiList() {
    if (this.currentCategory === "Search") {
      return this.emojiChunkList(this.resultEmojis);
    }
    return this.emojiChunkList(this.groupedEmojis[this.currentCategory]);
  }
  get noOverflow() {
    const list = this.emojiList;
    return list[list.length - 1].length <= 10;
  }
  get resultEmojis() {
    const compare = new RegExp(this.searchTerm.toLowerCase());
    if (!this.searchTerm) return [];
    return this.emojis.filter((emoji: Emoji) => {
      let match = false;
      emoji.aliases.forEach((alias) => (match = match || compare.test(alias)));
      return match;
    });
  }
  emojiChunkList(array: Emoji[]) {
    if (array.length <= 10) return [array];
    const len = array.length;
    let indexes: number[] = [];
    if (array.length <= 10) indexes = [len];
    else if (array.length <= 20) indexes = [Math.ceil(len * 0.5), len];
    else if (array.length <= 30)
      indexes = [Math.ceil(len * 0.33333), Math.ceil(len * 0.66666), len];
    else indexes = [Math.ceil(len * 0.25), Math.ceil(len * 0.5), Math.ceil(len * 0.75), len];

    return indexes.map((index, i) => array.slice(index === 0 ? 0 : indexes[i - 1], indexes[i]));
  }

  add(data: string) {
    this.change(this.value + data);
  }

  change(value: string) {
    this.$emit("input", value);
  }

  toggleSearch() {
    if (this.currentCategory === "Search") {
      this.currentCategory = "Peoples";
    } else {
      this.currentCategory = "Search";
      if (this.$refs.search) this.$nextTick(() => this.$refs.search.focus());
    }
  }
}
